import { methodShipment } from '../../../../Components/helper';
import type { SelectOption } from './types';

/**
 * Option sets for the Costing Information group dropdowns.
 *
 * Mirrors the product-costing-detail/add page: Costing Template is fetched per dev order (filtered by
 * brand/category — see `useMultiSubmitData`), MOQ Needed is a numeric input, and Shipment Method reuses
 * the shared `methodShipment` helper — there is no tenant master for shipment method.
 */

/** Shipment methods — the same shared list the add-costing page uses. */
export const SHIPMENT_METHOD_OPTIONS: SelectOption[] = (
  methodShipment as Array<{ value: string; label: string }>
).map((method) => ({ value: method.value, label: method.label }));

/** Shipment method pre-selected on every new row (Multi Submit only — the add page has no default). */
export const DEFAULT_SHIPMENT_METHOD = 'Sea';
